let scrollPosition = 0;

// Call when you open a dialog
export function lockScroll() {
  scrollPosition = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.width = '100%';
}

// Call when you close the dialog
export function unlockScroll() {
  if (document.body.style.position !== "fixed") return;

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, scrollPosition);
}
